import React from 'react';
import HelmetComponent from '../../utils/HelmetHelper';
import { requireUserAdOwnership, requireUserLogin, requireUserVerify } from '../../routes/Auth';
import PromotionPackages from './PromotionPackages';

const AdPromotePage = (props) => (
  <React.Fragment>
    <HelmetComponent title={`${"Istaknite oglas"} | ${"INDEX OGLASI"}`} index={false} />

    <PromotionPackages
      {...props}
    />
  </React.Fragment>
);

export default requireUserLogin(
  //requireUserVerify(
    requireUserAdOwnership(
      AdPromotePage
    )
  //)
);



// WEBPACK FOOTER //
// ./src/containers/AdPromotePage/index.tsx